import { Injectable } from '@angular/core';

import { Decimal } from 'decimal.js';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { CombinationRestrictions, ISlip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { BetStakeNotDividableValidator } from '../../validators/bets/bet-stake-not-dividable-validator.service';
import { ComboPreventionValidator } from '../../validators/bets/combo-prevention.validator';
import { MinimumCombinationValidator } from '../../validators/bets/minimum-combination.validator';
import { UnderMinimumStakeValidator } from '../../validators/bets/under-minimum-stake.validator';
import { UnderMinimumWinningsValidator } from '../../validators/bets/under-minimum-winnings.validator';

@Injectable()
export default class BetValidationService {
    constructor(
        private comboPreventionValidator: ComboPreventionValidator,
        private minimumComboValidator: MinimumCombinationValidator,
        private underMinimumStakeValidator: UnderMinimumStakeValidator,
        private betStakeNotDividableValidator: BetStakeNotDividableValidator,
        private underMinimumWinningsValidator: UnderMinimumWinningsValidator,
    ) {}

    getRestrictions(picks: BetslipPick[], isSystemBet: boolean, ignoreGroupPicks: boolean): CombinationRestrictions {
        const comboPreventionRestrictions = this.comboPreventionValidator.getRestrictions(picks, isSystemBet, ignoreGroupPicks);
        const minimumComboRestrictions = this.minimumComboValidator.getRestrictions(picks);

        return {
            notCombinablePicks: comboPreventionRestrictions,
            minimumCombinations: minimumComboRestrictions,
        };
    }

    checkComboBet(picks: BetslipPick[], restrictions?: CombinationRestrictions): boolean {
        if (!restrictions) {
            restrictions = this.getRestrictions(picks, false, false);
        }
        if (Object.keys(restrictions.notCombinablePicks).length > 0) {
            // Has not combinable picks in the combo bet
            return false;
        }
        if (Object.values(restrictions.minimumCombinations).some((v) => v < picks.length)) {
            // Has a pick which requires more picks
            return false;
        }

        return true;
    }

    validateSlipBets(slip: ISlip, possibleWinningsNet: Decimal | null): BetslipError[] {
        const picks = Object.values(slip.slipPicks).map((sp) => sp.pick);

        const minimumComboRestrictions = this.minimumComboValidator.getRestrictions(picks);
        const underMinStakeErrors = this.underMinimumStakeValidator.validate(slip);
        const betStakeNotDividable = this.betStakeNotDividableValidator.validate(slip);
        const underMinWinningsErrors = this.underMinimumWinningsValidator.validate(slip, possibleWinningsNet);

        return [
            ...this.minimumComboValidator.validateSlip(slip, minimumComboRestrictions),
            ...underMinStakeErrors,
            ...betStakeNotDividable,
            ...underMinWinningsErrors,
        ];
    }
}
